import styled from 'styled-components'

export const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	padding: 36px;

	border-radius: 7.6px;
	box-shadow: 0px 0px 19px -3px #0D0D0D17;

	@media(max-width: 920px) {
		flex-direction: column;
		gap: 36px;
	}
`

export const TitleContainer = styled.div`
	min-width: 166px;
	max-width: 166px;
	display: flex;
	align-items: center;
	justify-content: start;
`

export const Content = styled.div`
	display: flex;
	flex-direction: column;
`

export const Title = styled.h2`
	font-family: "Platform Web";
	font-size: 30px;
	line-height: 48px;
	font-weight: 500;
	color: #393939;
`

export const Subtitle = styled.span`
	font-family: "Work Sans";
	font-size: 16px;
	line-height: 22.8px;
	font-weight: 700;
	color: #393939;
`

export const Description = styled.p`
	font-family: "Work Sans";
	font-size: 16px;
	line-height: 22.8px;
	font-weight: 400;
	color: #393939;
`
